import React, { useState } from 'react';
import { LeadCommentModel, LeadFilterModel, LeadModel, SPLeadModel, SimulatorOfferModel, TreatmentModel } from '../models/superbit-api-models'
import { StatOptions } from 'fs';
import moment from 'moment';
import LeadOffer from '../leads/_LeadOffer'
import { LeadTreatment } from '../_LeadTreatment'
import { LinkToSimulator } from '../leads/_LinkToSimulator';
import { LeadsModel } from '../models/LeadsModel';
import OfferProduction from '../production/_OfferProduction'
import LeadTreatments from '../leads/_LeadTreatments';
import { setPhoneNumberOfLead } from '../app-context/leadsSlice';
import { connect } from 'react-redux';
import { RootState } from '../app-context/store';
import { set } from 'lodash';
import ClientPolicyDetails from '../clients/PolicyDetails/_ClientPolicyDetails';
import { PolicyModel } from '../models/PolicyModel'
import { GeneralDataModel } from '../models/GeneralDataModel'
import RenewalComments from './_RenewalComments'
import "./Renewal.css";

type Props = {
    lead: SPLeadModel | null;
    open: boolean;
    closeLead: any;
    onMenuClick: any;
    getAuthorizedToDriveName: any;
    openPopupMessage?: Function;
    simulatorPermission: boolean;
    isAdmin: boolean | undefined;
    phoneNumberOfLead: string;
    setPhoneNumberOfLead: (data: string) => void;

};

type State = {
    showBtnOptions: boolean;
    lead: LeadModel;
    leadData: SPLeadModel
    leadTopTypeLabel: string;
    //leadAdditionsString: string;
    offerSortBy: any;
    offersList: any[];
    productionOffer: SimulatorOfferModel | null;
    policy?: any;
    ExpandedInsuranceTypes: any;
    ExpandedInsuranceType: string;
};


class OpenRenewal extends React.Component<Props, State> {
    leadsModel: LeadsModel = new LeadsModel();
    constructor(props: any) {
        super(props);
        const leadTopTypes: string[] = [
            'רכב',
            'דירה/עסק',
            'אחר'
        ];
        let leadTopTypeLabel = leadTopTypes[0];
        // if (this.props.lead && this.state.lead && this.state.lead.leadTopType && this.state.lead.leadTopType > 0) {
        //     leadTopTypeLabel = leadTopTypes[this.state.lead.leadTopType];
        // }



        props.lead.lead.treatments && props.lead.lead.treatments.sort((a: any, b: any) => b.eventDate - a.eventDate)

        const offersList: any[] = this.props.lead != null && this.props.lead != null && this.props.lead.offers != null ? this.props.lead.offers : [];
        offersList.sort((a: any, b: any) => a.offerIdentity - b.offerIdentity)
        this.state = {
            showBtnOptions: false,
            lead: props.lead.lead,
            leadData: props.lead,
            leadTopTypeLabel: leadTopTypeLabel,
            //            leadAdditionsString: this.props.lead && this.state.lead && this.state.lead.leadAdditionsFromRelation ? this.buildLeadAdditionsString(this.state.lead.leadAdditionsFromRelation) : '',
            offerSortBy: {
                column: 'offerIdentity',
                direction: 'ASC'
            },
            offersList: offersList,
            productionOffer: null,
            policy: undefined,
            ExpandedInsuranceTypes: [],
            ExpandedInsuranceType: "",
        }
    }

    buildOffersList() {
        if (this.state.lead != null && this.state.lead != null && this.state.lead != null && this.state.lead.offers != null) {
            const offersList: any[] = this.state.lead.offers;
            // offersList.sort((a: any, b:any) => a.offerIdentity - b.offerIdentity);
            // offers.sort((a: any, b:any) => {
            //     return offersSort.direction == 'ASC' ? a[columnName] - b[columnName] : b[columnName] - a[columnName];
            // });
            this.setState({
                offersList: offersList
            });
        }


    }

    buildLeadAdditionsString(leadAdditionsFromRelation: any[]): string {
        let returnStr: string = '';
        leadAdditionsFromRelation.map((item) => {
            if (returnStr !== '') {
                returnStr += ', ';
            }
            returnStr += item.name;
        })
        return returnStr;
    }

    toggleBtnMenu() {
        const curentState = this.state.showBtnOptions;
        this.setState({
            showBtnOptions: !curentState
        })
    }
    onSimulatorClick = () => {
        if (this.state.lead && this.state.lead.id) {
            //console.log('Lead to Simulator', this.state.lead.id)
        }
    }
    onMenuClick(action: string, value?: string) {
        this.props.onMenuClick(action);
        this.toggleBtnMenu()
    }

    async componentDidMount() {

        setTimeout(() => {


            if (this.props.lead && this.state.lead && this.state.lead.phoneNumber1) {
                this.initPhoneNumberOfLead(this.state.lead.phoneNumber1);
            }

        }, 100);

        if (this.props.lead && this.state.lead && this.state.lead.policy && this.state.lead.policy.id) {
            var policy = await new PolicyModel().policyGetById(this.state.lead.policy.id);
            this.setState({ policy: policy });
        }

        moment.locale('he');
        this.sortOffers();


    }

    initPhoneNumberOfLead(phoneNumber: string) {
        setTimeout(() => {
            console.log('OpenLead', phoneNumber);
            this.props.setPhoneNumberOfLead(phoneNumber);
        }, 100);

    }

    closeLead(e: any) {
        if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
            e.target.className == 'action-btn-menu-item pointer' ||
            e.target.className == 'description cell-value phone-number' ||
            e.target.parentElement.className == 'cell car-details'
        ) return;
        this.props.closeLead();
    }

    onRefreshData() {
        if (this.state.lead != null && this.state.lead.id) {
            const leadId = this.state.lead.id.toString();
            const f: LeadFilterModel = new LeadFilterModel();
            f.LeadId = leadId;
            this.leadsModel.filter(f).then((res) => {
                const lead = this.state.lead;
                lead.offers = res.leads[0].lead.offers;
                lead.treatments = res.leads[0].lead.treatments;
                lead.treatments && lead.treatments.sort((a: any, b: any) => b.eventDate - a.eventDate)
                this.setState({
                    lead: lead
                })
                //console.log(res);
                this.sortOffers();
            });
        }
    }

    openPopupMessage(d: any) {
        if (this.props.openPopupMessage) {
            this.props.openPopupMessage(d);
        }
    }

    onOfferSortClick(columnName: string) {
        //console.log('onOfferSortClick');
        const offersSort = this.state.offerSortBy;
        if (columnName == offersSort.column) {
            offersSort.direction = offersSort.direction == 'ASC' ? 'DESC' : 'ASC';
        } else {
            offersSort.direction = 'ASC';
            offersSort.column = columnName;
        }
        if (this.state.lead != null && this.state.lead != null && this.state.lead.offers != null) {
            const lead = this.state.lead;
            const offers = this.state.lead.offers;

            lead.offers = [];
            this.setState({
                lead: lead
            });

            offers.sort((a: any, b: any) => {
                return offersSort.direction == 'ASC' ? a[columnName] - b[columnName] : b[columnName] - a[columnName];
            });
            lead.offers = offers;
            this.setState({
                offerSortBy: offersSort,
                lead: lead
            }, () => this.sortOffers());
        }
    }

    sortOffers() {
        const lead = this.state.lead;
        if (lead) {
            const offers = this.state.lead.offers;
            const offersSort = this.state.offerSortBy;
            if (offers) {
                offers.sort((a: any, b: any) => {
                    return offersSort.direction == 'ASC' ? a[offersSort.column] - b[offersSort.column] : b[offersSort.column] - a[offersSort.column];
                });

                lead.offers = offers;
                this.setState({
                    lead: lead
                }, () => this.buildOffersList());
            }

        }
    }

    checkPermissionsOfCreator() {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Leads');

            if (moodelPermision && moodelPermision.permissionType == 2) {
                return true;
            }
        }
        return false;
    }

    async getExpandedInsuranceType() {

        let jsonString = localStorage.getItem('ExpandedInsuranceTypes');
        let ExpandedInsuranceTypes: any[] = Object.values(jsonString ? JSON.parse(jsonString) : []);

        var arr = Array.isArray(ExpandedInsuranceTypes);

        if (!ExpandedInsuranceTypes || ExpandedInsuranceTypes.length === 0) {
            ExpandedInsuranceTypes = await new GeneralDataModel().getExpandedInsuranceTypes();
            localStorage.setItem('ExpandedInsuranceTypes', JSON.stringify(ExpandedInsuranceTypes));
        }

        if (ExpandedInsuranceTypes && this.props.lead && this.props.lead.lead && this.props.lead.lead.policy && this.props.lead.lead.policy.policyAdditionDetails) {
            var type = this.props.lead.lead.policy.policyAdditionDetails.vehiclePolicyType;

            const item = ExpandedInsuranceTypes.find((x: any) => x.id === type);
            const desc = item ? item.description : "";
            this.setState({ ExpandedInsuranceType: desc });
        }
    }

    render() {
        let vehicle = null;
        if (this.state.lead != null && this.state.lead != null) {
            vehicle = this.state.lead.vehicle;
            //console.log('vehicle', vehicle)
        }



        return (
            <>
                {/* {
                    this.state.productionOffer && <OfferProduction offer={this.state.productionOffer} closeProduction={this.closeProduction} />
                } */}
                <div>
                    {this.state.lead != null ? (
                        <div className={this.props.open ? "data-card-row opened" : "hide"} >
                                <div className="body-line" onClick={(e: any) => this.closeLead(e)}>
                                    <div className="empty-cell">
                                        <div className={this.state.lead != null && this.state.lead.offers != null && this.state.lead.offers.length > 0 ? "icon tag" : ""}></div>
                                    </div>
                                    <div className="status-cell">
                                        <div className="title">סטטוס</div>
                                        <div className="flex-end">
                                            <div className="status flex-centered flex-space-between">
                                                <div className="status-circle"></div>
                                                <div className="sub-title">{this.state.leadData.lastStatusName}</div>
                                                <div className="qty">
                                                    <div className={this.state.lead.doubleLead ? "qty-circle" : "hide"}></div>
                                                    <div className={this.state.lead.doubleLead ? "qty-number flex-centered flex-justify-center" : "hide"}>x2</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="fullName-cell">
                                            {this.state.lead ? this.state.lead.fullName : ""}
                                    </div>
                                    <div className="identifier-cell">
                                            {this.state.lead.customer ? this.state.lead.customer.identifier : ""}
                                    </div>
                                    <div className="phoneNumber-cell on-click-ignore">
                                            <div className="">{this.state.lead.phoneNumber1}</div>
                                    </div>
                                    <div className="carDetails-cell on-click-ignore">
                                        {
                                            this.state.lead.leadTopType == 0 ? (<>
                                                <div className="sub-title">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.vehicleSubModel.modelCode : ""}</div>
                                                <div className="description">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.vehicleSubModel.name : ""}</div>
                                                <div className="description">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.licenseNumber : ""}</div>
                                            </>) : ''
                                        }
                                    </div>
                                    <div className="policyNumber-cell">
                                            {this.state.lead.policy ? this.state.lead.policy.policyNumber : ""}
                                    </div>
                                    <div className="policyType-cell">
                                            {this.state.lead.policy && this.state.lead.policy.policyType ? this.state.lead.policy.policyType.name : ""}
                                    </div>
                                    <div className="policyType-cell">
                                            {this.state.ExpandedInsuranceType}
                                    </div>
                                    <div className="company-cell">
                                            {this.state.lead && this.state.lead.renewalRoute && this.state.lead.renewalRoute.insuranceCompany ? this.state.lead.renewalRoute.insuranceCompany.name : ""}
                                    </div>
                                    <div className="branch-cell">
                                            {this.state.lead && this.state.lead.renewalRoute ? (this.state.lead.renewalRoute.routeId ? this.state.lead.renewalRoute.routeId : "") + " - " + (this.state.lead.renewalRoute.comment ? this.state.lead.renewalRoute.comment : "") : ""}
                                    </div>
                                    <div className="endDate-cell">
                                            {this.state.lead && this.state.lead.policy ? moment(this.state.lead.policy.endDate).format('DD-MM-YYYY') : ""}
                                    </div>
                                    <div className='option-cell desktop-only' >
                                        {/* <button className="act-btn"
                        onClick={()=>{this.toggleBtnMenu()}}
                    >
                        פעולות
                    </button> */}
                                        <div className='act-btn-icon icon menu-hamburger pointer'
                                            onClick={() => { this.toggleBtnMenu() }}></div>
                                        {this.state.showBtnOptions && (
                                            <ul className="btn-menu">
                                                {this.checkPermissionsOfCreator() ? (
                                                    <li className="action-btn-menu-item pointer"
                                                        onClick={() => { this.onMenuClick('edit') }}
                                                    >
                                                        ערוך
                                                    </li>
                                                ) : (<></>)}
                                                {this.props.isAdmin ? (
                                                    <li className="action-btn-menu-item pointer">
                                                        מחק
                                                    </li>
                                                ) : (<></>)}
                                                <li className="action-btn-menu-item pointer">
                                                    הדפס
                                                </li>
                                                {/* <li className="action-btn-menu-item pointer"
                                    onClick={()=>{this.onMenuClick('simulator')}}
                                >
                                    סימולטור
                                </li> */}
                                                {this.props.simulatorPermission && this.state.leadData && this.state.lead && this.state.lead.id && this.state.lead.leadTopType == 0 && (
                                                    <LinkToSimulator
                                                        onClick={() => { this.onSimulatorClick() }}
                                                        leadId={this.state.lead.id}
                                                    ></LinkToSimulator>
                                                )
                                                }
                                            </ul>
                                        )}
                                    </div>
                                    <div className="action-cell" >
                                        <div className="icon left-arrow toggle-leed" onClick={(e: any) => this.closeLead(e)}></div>
                                    </div>
                                {/* <div className="bottom-row flex-space-between flex-centered">
                                    <div className="bottom-actions flex-space-between flex-centered">
                                        <div className="icon tag"></div>
                                        <div className="license flex-space-between flex-centered">
                                            <div className="icon paperclip"></div>
                                            <div>רישיון</div>
                                        </div>
                                    </div>
                                    <div>
                                        <button className="act-btn">פעולות</button>
                                    </div>
                                </div> */}
                            </div>
                            <div className="data-card-details">

                            </div>
                            {this.state.policy ? <ClientPolicyDetails data={this.state.policy} fromRenewals={true} customerData={this.state.lead}  /> : ""}

                            <div className="details-row no-padding offers">
                                <div className="row-title">
                                    הצעות
                                </div>
                                <div id="offersTbl" className="content-table-header flex-centered flex-space-between">
                                    <div className="cell status pointer" onClick={() => this.onOfferSortClick('offerIdentity')}>
                                        מס'
                                        {
                                            this.state.offerSortBy.column == 'offerIdentity' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'offerIdentity' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell date flex-centered flex-space-between pointer" onClick={() => this.onOfferSortClick('startDate')}>
                                        ת. יצירה
                                        {
                                            this.state.offerSortBy.column == 'startDate' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'startDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell date flex-centered flex-space-between pointer" onClick={() => this.onOfferSortClick('endDate')}>
                                        ת. תחילה
                                        {
                                            this.state.offerSortBy.column == 'endDate' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'endDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell date flex-centered flex-space-between pointer" onClick={() => this.onOfferSortClick('createdDate')}>
                                        ת. סיום
                                        {
                                            this.state.offerSortBy.column == 'createdDate' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'createdDate' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell pointer" onClick={() => this.onOfferSortClick('driverMainAge')}>
                                        גיל עיקרי
                                        {
                                            this.state.offerSortBy.column == 'driverMainAge' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'driverMainAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell pointer" onClick={() => this.onOfferSortClick('driverYoungAge')}>
                                        גיל צעיר
                                        {
                                            this.state.offerSortBy.column == 'driverYoungAge' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'driverYoungAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div style={{ width: 80, paddingBottom: '20px' }} onClick={() => this.onOfferSortClick('driverYoungAge')}>
                                        מספר נהגים
                                        {
                                            this.state.offerSortBy.column == 'driverYoungAge' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'driverYoungAge' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell wide pointer" onClick={() => this.onOfferSortClick('vehicleSubModel')}>
                                        קוד דגם
                                        {
                                            this.state.offerSortBy.column == 'vehicleSubModel' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'vehicleSubModel' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div style={{ width: 80, paddingBottom: '20px' }} onClick={() => this.onOfferSortClick('insuranceCompany')}>
                                        חברה
                                        {
                                            this.state.offerSortBy.column == 'insuranceCompany' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'insuranceCompany' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div style={{ width: 80, paddingBottom: '20px' }} onClick={() => this.onOfferSortClick('insuranceType')}>
                                        עבר ביטוחי
                                        {
                                            this.state.offerSortBy.column == 'insuranceType' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'insuranceType' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>

                                    <div className="cell-price-pointer">
                                        מיגון

                                    </div>
                                    <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('compulsoryPremium')}>
                                        חובה
                                        {
                                            this.state.offerSortBy.column == 'compulsoryPremium' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'compulsoryPremium' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('cascoPremium')}>
                                        קסקו
                                        {
                                            this.state.offerSortBy.column == 'cascoPremium' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'cascoPremium' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('ridersSum')}>
                                        חבילות
                                        {
                                            this.state.offerSortBy.column == 'ridersSum' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'ridersSum' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell-price-pointer" onClick={() => this.onOfferSortClick('totalSum')}>
                                        סה"כ
                                        {
                                            this.state.offerSortBy.column == 'totalSum' ? (
                                                <div className={`icon sort ${this.state.offerSortBy && this.state.offerSortBy.column == 'totalSum' ? this.state.offerSortBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                    }`}></div>
                                            ) : (<></>)
                                        }
                                    </div>
                                    <div className="cell offer-button-cell actions">

                                    </div>
                                </div>
                                {this.state.offersList && this.state.offersList != null ? this.state.offersList.map((offer: SimulatorOfferModel, index: number) => {
                                    return (
                                        <>
                                            <LeadOffer
                                                offer={offer}
                                                getAuthorizedToDriveName={this.props.getAuthorizedToDriveName}
                                                key={index}
                                                emailAddress={this.props.lead && this.props.lead.lead && this.props.lead.lead.email ? this.props.lead.lead.email : ''}
                                                onRefreshData={() => this.onRefreshData()}
                                                openPopupMessage={(d: any) => this.openPopupMessage(d)}
                                                leadId={this.state.lead.id}
                                                OpenProduction={""}
                                            // onProductionClick={this.openProduction}
                                            ></LeadOffer>
                                        </>
                                    )
                                }) : ""}

                            </div>
                            {this.props.lead && this.props.lead.lead && this.props.lead.lead.leadComments?<RenewalComments data={this.props.lead.lead.leadComments} />:""}
                            

                            <LeadTreatments lead={this.props.lead} />
                        </div>
                    ) : (
                        <p>No lead</p>
                    )}
                </div>
            </>



        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatch,
        setPhoneNumberOfLead: (data: string) => dispatch(setPhoneNumberOfLead(data)),
    }
}

const mapStateToProps = (state: RootState) => ({
    phoneNumberOfLead: state.leads.phoneNumberOfLead,
});

export default connect(mapStateToProps, mapDispatchToProps)(OpenRenewal);
